export default __webpack_public_path__ + "static/media/jubilee-mashup-compress.8728d521.mp4";